import styled, { CSSObject } from '@emotion/styled'
import { FusionColor, FusionContentZIndex } from '../../../../theme/FusionStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faBan } from '@fortawesome/pro-solid-svg-icons'
import { V2L1LoadingIndicator } from '../../Indicator/V2L1LoadingIndicator'
import { DashboardLoadItemStatus } from '@fusion-advantage/formlib'

type V2L2DashboardListItemActiveColor = FusionColor.OrangeMain|FusionColor.BlueMain

export interface V2L2DashboardListItemRootProps {
	status: DashboardLoadItemStatus
	active: boolean
	activeColor: V2L2DashboardListItemActiveColor
}

const V2L2DashboardListItemRoot = styled.button<V2L2DashboardListItemRootProps>(({theme, status, active, activeColor}) => {
	const style: CSSObject = {
		all: 'unset',
		backgroundColor: active ? theme.colors[activeColor] : theme.colors.second,
		color: active ? theme.colors.white : 'inherit',
		borderRadius: theme.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: (status === DashboardLoadItemStatus.Loading) ? 'center' : 'space-between',
		alignItems: 'center',
		padding: '1rem',
		cursor: 'pointer',
		userSelect: 'none',
		zIndex: active ? FusionContentZIndex.Content + 1 : FusionContentZIndex.Content
	}
	switch(status) {
		case DashboardLoadItemStatus.Loading:
			style.justifyContent = 'center'
			break
		case DashboardLoadItemStatus.Error:
		case DashboardLoadItemStatus.Cancelled:
			if(!active) {
				style.color = theme.colors[FusionColor.StopRed]
			}
			break
	}
	return style
})

const Title = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	gap: '.5rem',
	alignItems: 'center',
	...theme.fonts.bodyBold,
	fontSize: '1rem',
}))

const Subtitle = styled.div({
	fontSize: `${14/16}rem`,
})

export interface V2L2DashboardListItemProps {
	className?: string
	status: DashboardLoadItemStatus
	active: boolean
	activeColor: V2L2DashboardListItemActiveColor
	onClick?: React.MouseEventHandler<HTMLButtonElement>
	title: string
	subtitle?: string
	id?: string
}

export const V2L2DashboardListItem = ({className, status, active, activeColor, onClick, title, subtitle, id}: V2L2DashboardListItemProps) => {
	return (
		<V2L2DashboardListItemRoot
			className={className}
			status={status}
			active={active}
			activeColor={activeColor}
			onClick={onClick}
		>
			{status === DashboardLoadItemStatus.Loading ? (
				<V2L1LoadingIndicator />
			) : (
				<>
					<div>
						<Title>
							{status === DashboardLoadItemStatus.Error ? (
								<FontAwesomeIcon icon={faExclamationTriangle} />
							) : null}
							{status === DashboardLoadItemStatus.Cancelled ? (
								<FontAwesomeIcon icon={faBan} />
							) : null}
							{title}
						</Title>
						{subtitle ? (
							<Subtitle>{subtitle}</Subtitle>
						) : null}
					</div>
					{id ? (
						<Subtitle>{id}</Subtitle>
					) : null}
				</>
			)}
		</V2L2DashboardListItemRoot>
	)
}
